<template>
    <mu-infinite-scroll :loading="load" loadingText="拼命加载中" class="load" v-if="load" />
	<div class="wrap login-wrap flex-column" v-else>
		<mu-appbar title="登录" titleClass="custom-appbar-title" class="custom-appbar">
		    <img src="/static/images/login_back_3x.png" slot="left" @click="goback">
		</mu-appbar>
		<div class="flex-item">
			<form class="login-content">
				<div class="input-box">
					<label>手机号</label>
					<input class="small-input" type="text" @blur="checkMobile" @change="checkMobile"  v-model="mobile"  minlength="11" maxlength="11" placeholder="请输入手机号"></input>
				</div>
				<div class="input-box">
					<label>图片验证码</label>
					<input class="small-input" type="text"  v-model="randomCode" maxlength="4" placeholder="请输入验证码"></input>
					<span class="img-code-box"><img :src="randomCodePath"  @click="refreshImgCode"/></span>
				</div>
				<div class="input-box">
					<label>短信验证码</label>
					<input class="small-input" type="text" @blur="checkAuthCode" @change="checkAuthCode"  v-model="authCode" maxlength="4" placeholder="请输入验证码"></input>
					<mu-raised-button :label="getauthCodeTip" class="getyz-btn"  @click="getValidateCode"  @change="":disabled="isGetauthCode"/>
				</div>
				<p class="el-input-error">{{tip}}</p>
				<div class="">
					<mu-raised-button label="登录" fullWidth @click="login" v-if="isFormValid()"/>
					<mu-raised-button label="登录" fullWidth disabled v-else/>
					<!-- <mu-raised-button label="退出登录" fullWidth @click="loginOut"/> -->
				</div>
				
			</form>
			<div class="tripartite-box">
				<span class="wxauth-title">
					美心商城手机版
				</span>
				<br/>
				<img v-if="isWxBrowser()" @click="loginForWx" src="/static/images/login_wechat_3x.png" >
				<img v-else @click="tQHandler"  src="/static/images/mexin_logo_3x.png" style="width:auto;">
				<p>登录即代表您已同意美心隐私政策</p>
			</div>
		</div>
		<mu-toast v-if="toast.isShow" :message="toast.messageTip" class="custom-toast" />
	</div>
</template>
<script type="text/javascript">
import imgs from "@components/image/image";
import { mapActions, mapGetters } from "vuex";
import Constant from "@/Constant";
import { storage } from "@common/utils/util.js";
export default {
  data() {
    return {
      mobile: null,
      authCode: null,
      getauthCodeTip: "获取验证码", //获取验证码按钮内容
      isGetauthCode: false, //是否点击获取二维码按钮
      tip: "",
      load: true,
      toast: {
        isShow: false,
        messageTip: "",
      },
      randomCodePath: "",
      randomCode: "",
    };
  },
  created() {
    this.getLoginToken({
      p0: "",
    }).then((res) => {
      this.userAttrId = storage.session.get("userAttrId");
      this.randomCodePath =
        Constant.imgBaseUrl +
        "/random?v=" +
        Math.random() +
        "&userAttrId=" +
        this.userAttrId;
    });

    this.load = false;
  },
  mounted() {
    this.$nextTick(function () {
      window.addEventListener(
        "popstate",
        function (e) {
          // window.history.go(-2);//页面回退两次   ps:-> auth -> 之前页面
        },
        false
      );
    });
  },
  methods: {
    ...mapActions({
      sendAuthCodeSms: "sendAuthCodeSms",
      getLoginToken: "getLoginToken", //获取token
      quickLogin: "quickLogin",
      quickLoginWithCode: "quickLoginWithCode",
      doWxMpLogin: "doWxMpLogin",
      doLogin: "doLogin",
      saveWxLogin: "saveWxLogin",
      saveUserInfo: "saveUserInfo",
      logout: "logout",
      connectOauth2Authorize: "connectOauth2Authorize", //5.2.生成微信网页授URL-用户同意授权获取code
      updateMemCartForUserLogin: "updateMemCartForUserLogin",
    }),
    showTipMessage(isShow, msg) {
      this.toast.isShow = isShow;
      this.toast.messageTip = msg;
      setTimeout(() => {
        this.toast.isShow = false;
      }, 1500);
    },
    //刷新图片验证码
    refreshImgCode() {
      this.userAttrId = storage.session.get("userAttrId");
      this.randomCodePath =
        Constant.imgBaseUrl +
        "/random?v=" +
        Math.random() +
        "&userAttrId=" +
        this.userAttrId;
    },
    goback() {
      window.history.go(-2);
    },
    loginOut() {
      this.logout([]).then((res) => {
        //alert("退出成功")
        storage.local.remove("userInfo");
        console.log("res", res);
      });
    },

    //表单填写有效
    isFormValid() {
      return (
        this.authCode &&
        /^[0-9]{4,6}$/.test(this.authCode) &&
        this.mobile &&
        /^1\d{10}$/.test(this.mobile)
      );
    },

    //是否微信浏览器
    isWxBrowser() {
      return this.util.isWeiXin();
    },

    //获取验证码
    getValidateCode() {
      if (!/^1\d{10}$/.test(this.mobile)) {
        this.showTipMessage(true, "请输入正确的手机号码");
        return;
      }

      if (!this.randomCode) {
        this.showTipMessage(true, "请输入图片验证码");
        return;
      }

      this.sendAuthCodeSms([this.mobile, this.randomCode]).then((res) => {
        this.intervalyz();
      });
      return;
    },
    // 开启验证码倒计时
    intervalyz() {
      this.isGetauthCode = true;
      let conunt = 60;
      this.getauthCodeTip = conunt + "s后重新获取";
      this.yzInterval = setInterval(() => {
        conunt--;
        this.getauthCodeTip = conunt + "s后重新获取";
        if (conunt == 0) {
          this.getauthCodeTip = "重新获取验证码";
          clearInterval(this.yzInterval);
          this.isGetauthCode = false;
        }
      }, 1000);
    },
    checkMobile() {
      if (!/^1\d{10}$/.test(this.mobile)) {
        this.showTipMessage(true, "请输入正确的手机号码");
        // this.tip='请输入正确的手机号码'
        return;
      }
    },
    checkAuthCode() {
      if (!/^1\d{10}$/.test(this.mobile)) {
        this.showTipMessage(true, "请输入正确的手机号码");
        // this.tip='请输入正确的手机号码'
        return;
      }
      if (!/^[0-9]{4,6}$/.test(this.authCode)) {
        this.showTipMessage(true, "请输入正确的验证码");
        // this.tip='请输入正确的验证码'
        return;
      } else {
        this.tip = "";
      }
    },
    //登录
    login() {
      //alert('当前地址：'+location.href);
      let wxCode =
        this.$route.query["code"] ||
        this.util.parseString(location.href, "&", "code");

      //alert('mobile:'+this.mobile + ',authCode:' + this.authCode +',wxCode:'+wxCode)
      //this.quickLogin([this.mobile,this.authCode,'WEIXIN'])
      if (wxCode) {
        this.doLoginWithWxCode(wxCode);
      } else {
        this.doLoginWithUnWxCode();
      }
    },

    doLoginWithWxCode(wxCode) {
      this.quickLoginWithCode([this.mobile, this.authCode, wxCode])
        .then((res) => {
          //alert('quickLoginWithCode:' + JSON.stringify(res))
          return this.doLogin({
            openId: res.openId,
            clientType: "WEIXIN",
            authToken: res.authToken,
          });
        })
        .then((res) => {
          this.showTipMessage(true, "登录成功");
          this.updateMemCartForUserLogin();
          let redirect = decodeURIComponent(this.$route.query.redirect || "/");
          //完整URL
          if (redirect.startsWith("http")) {
            location.href = redirect;
          } else {
            this.$router.push({
              path: redirect,
            });
          }
        })
        .catch((err) => {
          this.showTipMessage(true, err || "登录失败");
        });
    },

    doLoginWithUnWxCode() {
      this.quickLogin([this.mobile, this.authCode, "WEIXIN"])
        .then((res) => {
          // alert('quickLogin:' + JSON.stringify(res))
          return this.doLogin({
            openId: res.openId,
            clientType: "WEIXIN",
            authToken: res.authToken,
          });
        })
        .then((res) => {
          console.log(res);
          this.showTipMessage(true, "登录成功");
          this.updateMemCartForUserLogin();
          let redirect = decodeURIComponent(this.$route.query.redirect || "/");
          //完整URL
          if (redirect.startsWith("http")) {
            location.href = redirect;
          } else {
            this.$router.push({
              path: redirect,
            });
          }
        })
        .catch((err) => {
          this.showTipMessage(true, err || "登录失败");
        });
    },

    //微信授权登录
    loginForWx() {
      //获取授权
      this.doWxAutoLogin();
    },

    doWxAutoLogin() {
      let wxCode = this.$route.query.code;
      //alert("doWxAutoLogin code:"+wxCode);

      this.doWxMpLogin([wxCode])
        .then((res) => {
          //alert("doWxMpLogin-"+ JSON.stringify(res));
          if (res.success && res.target && res.target.success) {
            let memData = res.target.target;
            //alert("memData-"+ JSON.stringify(memData));

            //调用loginCall/login方法，注册用户登录状态
            this.doLogin({
              openId: memData.openId,
              clientType: "WEIXIN",
              authToken: memData.authToken,
            }).then((res) => {
              //alert("调用loginCall-"+res)
              let redirect = decodeURIComponent(
                this.$route.query.redirect || "/"
              );
              this.updateMemCartForUserLogin();
              //完整URL
              if (redirect.startsWith("http")) {
                location.href = redirect;
              } else {
                this.$router.push({
                  path: redirect,
                });
              }
            });
          } else {
            //alert('微信CODE登录失败： '+(res && (res.message || res.target.message))|| "微信自动登录失败");
            this.toLoginPage();
          }
        })
        .catch((err) => {
          //alert('微信CODE登录失败： '+JSON.stringify(err));
          this.toLoginPage();
        });
    },

    doWxAutoLoginbk() {
      let redirectURL = this.$route.query.redirect || "";
      let prevFix = redirectURL.includes("?")
        ? "&autologin=true"
        : "?autologin=true";
      redirectURL += prevFix;

      this.connectOauth2Authorize([redirectURL]).then((res) => {
        //alert('微信授权结果： doWxAutoLogin- '+JSON.stringify(res.target));
        if (res.target) {
          // 重定向至微信
          let url = res.target;

          //alert('oauth2 授权后的URL >>> ' + url);
          location.replace(url);
        }
      });
    },

    // 感谢语
    tQHandler() {
      alert("美心商城欢迎您！竭诚为您服务！");
    },
  },
  components: {
    imgs,
  },
};
</script>
<style lang="scss" rel="stylesheet/scss">
@import "src/common/sass/mixin.scss";
.wrap.login-wrap {
  background: #fff;
  .custom-appbar {
    height: 1.05rem;
    border-top: 1px solid #d7d7d7;
    background: #f8f8f8;
    .left {
      img {
        height: 0.5rem;
      }
    }
    .custom-appbar-title {
      color: #666666;
      @include font-dpr(16px);
      text-align: center;
    }
  }
  .login-content {
    margin: 1.5rem 0.35rem 0 0.35rem;
    .input-box {
      position: relative;
      margin-top: 0.4rem;
      height: 1.1rem;
      border-bottom: 1px solid #e5e5e5;
      @include font-dpr(14px);
      label {
        width: 1.95rem;
        display: -webkit-inline-box;
      }
      .small-input {
        height: 0.81rem;
        width: 60%;
        background: rgba(255, 255, 255, 0);
      }

      .getyz-btn {
        color: #333;
        height: 0.85rem;
        box-shadow: 0 1px 6px rgba(0, 0, 0, 0), 0 1px 4px rgba(0, 0, 0, 0);
        border: 1px solid #e5e5e5;
        position: absolute;
        right: 0rem;
        bottom: 0.3rem;
      }
    }
    .img-code-box {
      img {
        width: 1.48rem;
      }
    }
    .el-input-error {
      color: #e60012;
      margin-top: 0.5rem;
    }
    .mu-raised-button.disabled {
      color: #999;
      background-color: #eee;
    }
    .mu-raised-button-full {
      @include font-dpr(16px);
      margin-top: 1.5rem;
      height: 1.05rem;
      background-color: #e60012;
      color: #fff;
    }
  }
  .tripartite-box {
    text-align: center;
    margin: 0.5rem 0.35rem;
    margin-top: 1rem;
    .wxauth-title {
      color: #999;
      @include font-dpr(14px);
      padding: 0 3rem;
      position: relative;
      &:before,
      &:after {
        content: "";
        display: inline-block;
        width: 2.5rem;
        height: 1px;
        position: absolute;
        top: 50%;
        background: #e5e5e5;
      }
      &:before {
        left: 0;
      }
      &:after {
        right: 0;
      }
    }
    img {
      margin-top: 0.5rem;
      width: 0.8rem;
      height: 0.8rem;
    }
    p {
      margin-top: 0.5rem;
      color: #666;
      @include font-dpr(12px);
    }
  }
}
</style>


// WEBPACK FOOTER //
// login.vue?7e509ae0